import { Button, Icon, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const EditButton = ({ className = '' }) => {
  const { t } = useTranslation()

  return (
    <Tooltip title={t(`services::accesses.list.extra_actions.edit`)}>
      <Button
        color={'Interface-Eighth'}
        startIcon={<Icon name={'pen'} />}
        noLabel
        size={'s'}
        className={className}
      />
    </Tooltip>
  )
}

EditButton.propTypes = {
  action: PropTypes.string,
  login: PropTypes.string,
  icon: PropTypes.string,
  processing: PropTypes.bool,
  className: PropTypes.string,
  toggleTo: PropTypes.oneOf(['activate', 'archive']),
  checkboxHandleChange: PropTypes.func,
  onClick: PropTypes.func,
}
